import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import { TypographyText } from '~/core/ui/Text'
import { cn } from '~/core/ui/utils'
import LPContainer from './LPContainer'

const SkillsFoundationSection: FCC<{ className?: string }> = ({
  className
}) => {
  const { t } = useTranslation()

  return (
    <LPContainer
      className={cn(
        'pb-5 mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0',
        className
      )}>
      <div className="flex flex-col tablet:flex-row items-center tablet:space-x-10 space-y-10 tablet:space-y-0">
        <div className="flex-1">
          {/* <span className="px-2 text-base uppercase rounded bg-blue-100 text-blue-800">
            {t('solutions:skills_foundation:tag')}
          </span> */}
          <p
            className={cn(
              'mt-3 mb-4 text-[31px] leading-[36px] tablet:text-[37px] tablet:leading-[42px] font-medium tablet:max-w-[820px] max-w-[343px] text-gray-900'
            )}
            dangerouslySetInnerHTML={{
              __html: t('solutions:skills_foundation:title')
            }}
          />
          <TypographyText className="text-base font-normal text-gray-700">
            {t('solutions:skills_foundation:description')}
          </TypographyText>
        </div>

        <Image
          src="/img/feature/lp/new/solutionSkillsFoundation.png"
          width={495}
          height={0}
          alt="feature 02"
          className="h-auto"
        />
      </div>
    </LPContainer>
  )
}

export default SkillsFoundationSection
